import {
	packageDataMock,
	activeSubscriptionsMock,
	paymentLinkForSellerMock,
	customPackageDataMock,
    prebuiltPackageDataMock,
} from './cs-subscription-api-mocks';

import {
    getLinkAttribution,
} from '@bark/bark-core';

export async function getCsSubPackageData(mock = false) {
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			'seller/self-service-subscription/available-tiers',
			{},
			function (data) {
				mock ? resolve(packageDataMock) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(
						new Error(`Failed to get self service cs subscription tiers`),
					);
				resolve({});
			},
			'GET',
			Bark.apiVersionHeader('v1'),
		);
	});
}

export async function getPrebuiltPackageData(mock = false, uuid) {
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			`seller/self-service-subscription/prebuilt-package/${uuid}`,
			{},
			function (data) {
				mock ? resolve(prebuiltPackageDataMock) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(new Error(`Failed to get prebuilt package data`));
				resolve({});
			},
			'GET',
			Bark.apiVersionHeader('v1'),
		);
	});
}

export async function createSubscriptionForPrebuiltPackage(mock = false, uuid) {
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			`seller/self-service-subscription/prebuilt-package/${uuid}`,
			{},
			function (data) {
				mock ? resolve(paymentLinkForSellerMock) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(
						new Error(`Failed to create prebuilt package subscription`),
					);
				resolve({});
			},
			'POST',
			Bark.apiVersionHeader('v1'),
		);
	});
}

export async function deleteSubscriptionForPrebuiltPackage(mock = false, uuid) {
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			`seller/self-service-subscription/prebuilt-package/${uuid}`,
			{},
			function (data) {
				mock ? resolve({}) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(
						new Error(`Failed to delete prebuilt package subscription`),
					);
				resolve({});
			},
			'DELETE',
			Bark.apiVersionHeader('v1'),
		);
	});
}

export async function createSubscriptionForPackage(
	mock = false,
	subscriptionTier,
	paymentFrequency,
	numberOfLeads = undefined,
) {
	let payLoad = {
		subscription_tier: subscriptionTier,
		billing_interval: paymentFrequency,
        tracking: getLinkAttribution() ?? {},
	};
	if (numberOfLeads) payLoad.number_of_leads = numberOfLeads;
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			'seller/self-service-subscription/payment-link',
			payLoad,
			function (data) {
				mock ? resolve(paymentLinkForSellerMock) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(
						new Error(`Failed to get self service cs subscription payment link`),
					);
				reject({});
			},
			'POST',
			Bark.apiVersionHeader('v1'),
		);
	});
}

export async function getActiveSubscriptions(mock = false) {
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			'seller/self-service-subscription/active-subscriptions',
			{},
			function (data) {
				mock ? resolve(activeSubscriptionsMock) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(new Error(`Failed to get active subscriptions`));
				resolve({});
			},
			'GET',
			Bark.apiVersionHeader('v1'),
		);
	});
}

export async function getCsSubCustomPackageData(mock = false, nLeads) {
	return new Promise((resolve, reject) => {
		window?.Bark?.api(
			`seller/self-service-subscription/custom-tier/${nLeads}`,
			{},
			function (data) {
				mock ? resolve(customPackageDataMock()) : resolve(data);
			},
			function (error) {
				bugsnagClient &&
					bugsnagClient.notify(
						new Error(`Failed to get data for cs subscription custom package`),
					);
				mock ? resolve(customPackageDataMock()) : resolve({});
			},
			'GET',
			Bark.apiVersionHeader('v1'),
		);
	});
}
